// extracted by mini-css-extract-plugin
export default {"wrapper":"StackedPapers_wrapper__dmnta","topPage":"StackedPapers_topPage__NVbfU","backPage":"StackedPapers_backPage__hllpw","likeAnimation":"StackedPapers_likeAnimation__RhcHc"};